import { FC, useState } from 'react';
import AudioExternal, {
  AudioSourceTypes
} from 'common/components/audio/audio-external';
import { useGetInboundCallRecordingUrlByHashQuery } from 'app/apis/queryApi';

interface PublicCallRecordingProps {
  siteId: string;
  hash: string;
}

const PublicCallRecording = ({ siteId, hash }: PublicCallRecordingProps) => {
  const [hasInitialisedRecording, setHasInitialisedRecording] = useState(false);

  const { data, isLoading, isUninitialized } =
    useGetInboundCallRecordingUrlByHashQuery(
      {
        siteId,
        hash
      },
      { skip: !hasInitialisedRecording }
    );

  const isRecordingInvalid = !data && !isUninitialized && !isLoading;

  return (
    <>
      <div>
        <label
          htmlFor={hash}
          className={`block mb-1 text-sm text-center ${
            isRecordingInvalid ? 'text-error-300' : ''
          }`}
        >
          {isRecordingInvalid ? (
            <>An error occurred when attempting to listen to the recording.</>
          ) : (
            <>Click play to listen to the call recording.</>
          )}
        </label>
        <AudioExternal
          identifier={hash}
          audioSource={data?.url}
          audioSourceType={AudioSourceTypes.AudioMpeg}
          isInitialising={isLoading}
          onInitialise={() => setHasInitialisedRecording(true)}
        />
      </div>
    </>
  );
};

export default PublicCallRecording;
